import type { BrowserConfig } from '../types';
import { trackCspViolations } from './cspViolations';

declare global {
  interface Window {
    NREUM?: {
      loader_config?: Record<string, unknown>;
      info?: Record<string, unknown>;
      init?: Record<string, unknown>;
      addPageAction?: (name: string, attributes: Record<string, unknown>) => void;
      setCustomAttribute?: (name: string, value: string | number | boolean) => void;
      noticeError?: (error: Error, customAttributes?: Record<string, unknown>) => void;
      setApplicationVersion?: (version: string) => void;
      setErrorHandler?: (handler: (err: Error) => boolean) => void;
    };
    newrelic?: Window['NREUM'];
  }
}

let isInitialized = false;

export const initializeBrowser = (config: BrowserConfig): void => {
  if (typeof window === 'undefined') return;

  if (isInitialized) return;

  const { accountId, applicationId, licenseKey } = config;

  if (!accountId || !applicationId || !licenseKey) {
    console.warn('Browser monitoring: Missing configuration, skipping initialization');
    return;
  }

  isInitialized = true;

  window.NREUM = window.NREUM || {};
  window.NREUM.loader_config = {
    accountID: accountId,
    trustKey: accountId,
    agentID: applicationId,
    licenseKey: licenseKey,
    applicationID: applicationId,
  };

  window.NREUM.info = {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: licenseKey,
    applicationID: applicationId,
    sa: 1,
  };

  const script = document.createElement('script');
  script.src = 'https://js-agent.newrelic.com/nr-loader-spa-current.min.js';
  script.async = true;
  script.onload = () => {
    console.log('Browser monitoring agent loaded');

    const agent = window.newrelic ?? window.NREUM;
    if (agent?.setErrorHandler) {
      agent.setErrorHandler((err) => {
        if (err?.message?.includes('ResizeObserver loop')) return true;
        return false;
      });
    }

    trackCspViolations();
  };
  script.onerror = () => {
    console.error('Failed to load browser monitoring agent');
  };

  document.head.appendChild(script);
};
